import React from 'react'
import styled from 'styled-components'

const ModeButtons = styled.div`
  display: flex;

  padding: 0.5rem;
  background-color: ${({ theme }) =>
    theme.modeButtonBackgroundColorUnactivated};
  border-radius: 2.5rem;
  box-shadow: ${({ theme }) => theme.modeButtonsShadow};
  font-size: 2.3rem;
  justify-content: center;
  align-items:center;
`

export default ModeButtons
